import { styled } from '@mui/material/styles';
import { getDrugTestThemeTokens } from '../themeTokens';
import type { ExpirationTone } from './types';

export const SectionLabel = styled('p')(({ theme }) => {
  const t = getDrugTestThemeTokens(theme);
  return {
    fontSize: 12,
    fontWeight: 700,
    textTransform: 'uppercase',
    letterSpacing: '0.06em',
    color: t.textMuted,
    margin: '28px 0 14px',
    paddingTop: 28,
    borderTop: `1px solid ${t.borderSoft}`,
  };
});

export const TimelineGrid = styled('div')(({ theme }) => {
  const t = getDrugTestThemeTokens(theme);
  return {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))',
    gap: '20px 32px',
    padding: '20px 24px',
    marginBottom: 28,
    background: t.surfaceMuted,
    border: `1px solid ${t.borderSoft}`,
    borderRadius: 8,
  };
});

export const TimelineItem = styled('div')({
  minWidth: 0,
});

export const TimelineLabel = styled('span')(({ theme }) => ({
  display: 'block',
  fontSize: 11,
  textTransform: 'uppercase',
  letterSpacing: '0.04em',
  color: getDrugTestThemeTokens(theme).textMuted,
  marginBottom: 6,
  fontWeight: 600,
  lineHeight: 1.2,
}));

export const TimelineValue = styled('span')(({ theme }) => ({
  fontSize: 14,
  lineHeight: 1.45,
  display: 'block',
  color: getDrugTestThemeTokens(theme).text,
}));

export const ExpirationValue = styled('span', {
  shouldForwardProp: (prop) => prop !== 'tone',
})<{ tone?: ExpirationTone | null }>(({ theme, tone }) => {
  const t = getDrugTestThemeTokens(theme);
  const toneColor = tone === 'expired' ? t.expired : tone === 'expiring' ? t.expiring : t.text;
  return {
    fontSize: 14,
    lineHeight: 1.45,
    display: 'block',
    color: toneColor,
    fontWeight: tone ? 600 : 400,
  };
});
